import { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";

const navLinks = [
  { label: "What", href: "#what-we-do" },
  { label: "How", href: "#process" },
  { label: "Who", href: "#who-we-work-with" },
];

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/98 backdrop-blur-md shadow-[0_1px_0_0_rgba(226,232,240,0.8)]"
          : "bg-white/0"
      }`}
    >
      <div className="max-w-[1200px] mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a
          href="#hero"
          onClick={(e) => handleNavClick(e, "#hero")}
          data-testid="nav-logo"
          className="font-['Playfair_Display'] font-semibold text-xl md:text-2xl text-[#0F172A] tracking-tight"
        >
          BLD
        </a>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              data-testid={`nav-link-${link.href.slice(1)}`}
              className="text-[15px] font-medium text-[#475569] hover:text-[#0F172A] transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href=""
            onClick={(e) => { e.preventDefault(); window.Calendly?.initPopupWidget({url: 'https://calendly.com/bldventuresgroup-marketing/30min'}); }}
            data-testid="nav-cta-button"
            className="calendly-cta btn-primary-scale btn-icon-shift inline-flex items-center gap-2 bg-[#0064E0] text-white rounded-lg px-6 py-2.5 text-[15px] font-medium hover:bg-[#0052CC] transition-colors focus:outline-none focus:ring-2 focus:ring-[#0064E0] focus:ring-offset-2"
          >
            Book a Discovery Call
            <ArrowRight className="btn-arrow w-4 h-4" />
          </a>
        </div>

        {/* Mobile menu button */}
        <button
          data-testid="mobile-menu-button"
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden p-2 text-[#0F172A]"
          aria-label="Toggle menu"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {mobileOpen ? (
              <path d="M18 6L6 18M6 6l12 12" />
            ) : (
              <path d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-white border-b border-[#E2E8F0] px-6 pb-6"
        >
          <div className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="text-[16px] font-medium text-[#475569] hover:text-[#0F172A] py-2"
              >
                {link.label}
              </a>
            ))}
            <a
              href=""
              onClick={(e) => { e.preventDefault(); window.Calendly?.initPopupWidget({url: 'https://calendly.com/bldventuresgroup-marketing/30min'}); }}
              data-testid="mobile-nav-cta"
              className="calendly-cta btn-primary-scale btn-icon-shift inline-flex items-center justify-center gap-2 bg-[#0064E0] text-white rounded-lg px-6 py-3 text-[16px] font-medium hover:bg-[#0052CC] w-full"
            >
              Book a Discovery Call
              <ArrowRight className="btn-arrow w-4 h-4" />
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};
